"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _ClickAwayListener.ClickAwayListener;
    }
});
var _ClickAwayListener = require("./ClickAwayListener");
